import { AgentActivityWebService } from '@linktivity/gds-neo';
import { createServiceConfig } from '../config';

const config = createServiceConfig({
  Configuration: AgentActivityWebService.Configuration
});

export default config;
